import { render, staticRenderFns } from "./absolute.vue?vue&type=template&id=075428e9&scoped=true&lang=pug&"
import script from "./absolute.vue?vue&type=script&lang=js&"
export * from "./absolute.vue?vue&type=script&lang=js&"
import style0 from "./absolute.vue?vue&type=style&index=0&id=075428e9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075428e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('075428e9', component.options)
    } else {
      api.reload('075428e9', component.options)
    }
    module.hot.accept("./absolute.vue?vue&type=template&id=075428e9&scoped=true&lang=pug&", function () {
      api.rerender('075428e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/position/align/absolute.vue"
export default component.exports